import type { ChatTurn, Session } from "@/types/eryndal";
import { apiDelete, apiGet, apiPatch } from "./client";

export async function listSessions(limit = 50): Promise<Session[]> {
  const data = await apiGet<{ sessions: Session[] }>(`/chat/sessions?limit=${limit}`);
  return data.sessions ?? [];
}

export async function getSessionTurns(sessionId: string, limit = 200): Promise<ChatTurn[]> {
  const data = await apiGet<{ session_id: string; turns: ChatTurn[] }>(
    `/chat/sessions/${encodeURIComponent(sessionId)}/turns?limit=${limit}`,
  );
  return data.turns ?? [];
}

export async function deleteSession(sessionId: string): Promise<void> {
  await apiDelete(`/chat/sessions/${encodeURIComponent(sessionId)}`);
}

export async function patchSessionRouting(
  sessionId: string,
  patch: { force_class?: string | null; auto_approve_analysis?: boolean },
): Promise<void> {
  await apiPatch(`/chat/sessions/${encodeURIComponent(sessionId)}/routing`, patch);
}

export interface SessionAttachment {
  artifact_id: string;
  filename: string | null;
  media_type: string | null;
  chunk_count: number;
  created_at: string | null;
}

export async function getSessionAttachments(sessionId: string): Promise<SessionAttachment[]> {
  const data = await apiGet<{ session_id: string; attachments: SessionAttachment[] }>(
    `/chat/sessions/${encodeURIComponent(sessionId)}/attachments`,
  );
  return data.attachments ?? [];
}

export async function deleteSessionAttachment(
  sessionId: string,
  artifactId: string,
): Promise<{ deleted_chunks: number }> {
  const data = await apiDelete<{ deleted_chunks: number }>(
    `/chat/sessions/${encodeURIComponent(sessionId)}/attachments/${encodeURIComponent(artifactId)}`,
  );
  return data;
}
